import type { XAXisComponentOption, YAXisComponentOption } from 'echarts';
import { merge } from 'lodash';
import { formatValue, UnitOptions } from '@/core';
import { DEFAULT_Y_AXIS } from '../../panels-plugin/plugins/time-series-chart/time-series-chart-model';

/*
 * Populate yAxis or xAxis properties.
 * Returns an Array since multiple axes will be supported in the future.
 */
export function getFormattedAxis(axis?: YAXisComponentOption | XAXisComponentOption, unit?: UnitOptions) {
  // TODO: support alternate yAxis that shows on right side
  const AXIS_DEFAULT = {
    type: 'value',
    boundaryGap: [0, '10%'],
    axisLabel: {
      // Show label based on top-level `show` if not set.
      show: axis?.axisLabel?.show ?? axis?.show ?? DEFAULT_Y_AXIS.show,
      formatter: (value: number) => {
        return formatValue(value, unit);
      },
    },
  };
  return [merge(AXIS_DEFAULT, axis)];
}

/**
 * Calculate date range, used as a fallback when xAxis time range not passed as prop
 */
export function getDateRange(data: number[]) {
  const defaultRange = 3600000; // hour in ms
  if (data.length === 0) return defaultRange;
  const lastDatum = data[data.length - 1];
  if (data[0] === undefined || lastDatum === undefined) return defaultRange;
  return lastDatum - data[0];
}
